import { formatMoney } from 'accounting'

import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { SidebarModalListItem } from '@domain-group/suit-theme'

import useCreditNoteItem from '@hooks/useCreditNoteItem'

import type { CreditNoteItemModel } from '@models/types'

interface CreditNoteItemProps {
  creditNoteItem: CreditNoteItemModel,
}

const CreditNoteItem = (props: CreditNoteItemProps) => {
  const { creditNoteItem, creditNoteItem: { description, price } } = props

  const itemPayload = useCreditNoteItem(creditNoteItem)
  const { callbacks: { deleteCreditNoteItem: deleteFn } } = itemPayload

  return (

    <SidebarModalListItem title={description}>
      {/*
       // @ts-expect-error TS2339 */}
      <SidebarModalListItem.TertiaryText>
        {/*
         // @ts-expect-error TS2769 */}
        {formatMoney(price)}
        {/*
       // @ts-expect-error TS2339 */}
      </SidebarModalListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <SidebarModalListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <SidebarModalListItem.Icon
          icon={faTrashAlt}
          onClick={deleteFn}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </SidebarModalListItem.Actions>
    </SidebarModalListItem>
  )
}

export default CreditNoteItem
